
define('template!adminApiStatsBlockTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (whoami) { ;
__p += '\n  <div class="whoami ' +
__e( proxyIp ? 'warn' : '' ) +
'">\n    <i class="fa ' +
__e( proxyIp ? 'fa-exclamation-triangle' : 'fa-user-secret' ) +
'"></i>\n    ' +
((__t = ( _.i18n('admin.apiBlock.whoami', null, 'The server sees you as') )) == null ? '' : __t) +
'\n    <span class="tag">IP <b>' +
__e( whoami.ip || '?' ) +
'</b></span>\n    ';
 if (whoami.origin) { ;
__p += '<span class="tag">origin <b>' +
__e( whoami.origin ) +
'</b></span>';
 } ;
__p += '\n    ';
 if (whoami.host) { ;
__p += '<span class="tag">host <b>' +
__e( whoami.host ) +
'</b></span>';
 } ;
__p += '\n    ';
 if (proxyIp) { ;
__p += '\n      <div class="warn-text">' +
((__t = ( _.i18n('admin.apiBlock.proxyWarning', null, 'This is a private address: the server sees the proxy, not the visitor. IP rules would block everyone behind it. Set CHAT_FORWARDED_FOR_TRUSTED_HOPS on the backend before using IP rules.') )) == null ? '' : __t) +
'</div>\n    ';
 } ;
__p += '\n  </div>\n';
 } ;
__p += '\n\n';
 if (error) { ;
__p += '\n  <div class="error-box"><i class="fa fa-exclamation-triangle"></i> ' +
((__t = ( _.i18n('admin.apiBlock.loadError', null, 'Blocking data could not be loaded.') )) == null ? '' : __t) +
'</div>\n';
 } ;
__p += '\n\n<section class="panel">\n  <header class="panel-header">\n    <h3><i class="fa fa-ban"></i> ' +
((__t = ( _.i18n('admin.apiBlock.rules', null, 'Block rules') )) == null ? '' : __t) +
'\n      <span class="count">' +
__e( enforcedCount ) +
' ' +
((__t = ( _.i18n('admin.apiBlock.enforcedLower', null, 'enforced') )) == null ? '' : __t) +
'</span>\n      ';
 if (loadingRules) { ;
__p += '<i class="fa fa-spinner fa-spin"></i>';
 } ;
__p += '\n    </h3>\n  </header>\n\n  <form class="rule-form js-rule-form" autocomplete="off">\n    <select class="js-new-type" aria-label="Type">\n      <option value="IP" ' +
__e( newType === 'IP' ? 'selected' : '' ) +
'>IP / CIDR</option>\n      <option value="ORIGIN" ' +
__e( newType === 'ORIGIN' ? 'selected' : '' ) +
'>Origin</option>\n      <option value="HOST" ' +
__e( newType === 'HOST' ? 'selected' : '' ) +
'>Host</option>\n    </select>\n    <input type="text" class="js-new-pattern pattern" required placeholder="' +
__e( placeholder ) +
'" aria-label="Pattern" />\n    <input type="text" class="js-new-note note" maxlength="512" placeholder="' +
__e( _.i18n('admin.apiBlock.notePlaceholder', null, 'Why (optional)') ) +
'" aria-label="Note" />\n    <select class="js-new-expiry" aria-label="Duration">\n      <option value="never">' +
((__t = ( _.i18n('admin.apiBlock.permanent', null, 'Permanent') )) == null ? '' : __t) +
'</option>\n      <option value="1h">1 h</option>\n      <option value="24h">24 h</option>\n      <option value="7d">7 ' +
((__t = ( _.i18n('admin.apiBlock.days', null, 'days') )) == null ? '' : __t) +
'</option>\n      <option value="30d">30 ' +
((__t = ( _.i18n('admin.apiBlock.days', null, 'days') )) == null ? '' : __t) +
'</option>\n    </select>\n    <button type="submit" class="btn btn-danger"><i class="fa fa-ban"></i> ' +
((__t = ( _.i18n('admin.apiBlock.block', null, 'Block') )) == null ? '' : __t) +
'</button>\n  </form>\n  ';
 if (formError) { ;
__p += '<div class="form-error"><i class="fa fa-exclamation-circle"></i> ' +
__e( formError ) +
'</div>';
 } ;
__p += '\n  <p class="help">' +
((__t = ( _.i18n('admin.apiBlock.help', null, 'Origin = the site a browser call comes from (Origin header, else Referer). Host = the domain the client called. *.example.com matches the sub-domains, not example.com itself. Changes reach every server within 30 s.') )) == null ? '' : __t) +
'</p>\n\n  ';
 if (!rules.length && !loadingRules) { ;
__p += '\n    <div class="empty">' +
((__t = ( _.i18n('admin.apiBlock.noRules', null, 'Nothing is blocked') )) == null ? '' : __t) +
'</div>\n  ';
 } else if (rules.length) { ;
__p += '\n  <div class="table-scroll">\n  <table class="stats-table rules-table">\n    <thead>\n      <tr>\n        <th>' +
((__t = ( _.i18n('admin.apiBlock.type', null, 'Type') )) == null ? '' : __t) +
'</th>\n        <th>' +
((__t = ( _.i18n('admin.apiBlock.pattern', null, 'Pattern') )) == null ? '' : __t) +
'</th>\n        <th>' +
((__t = ( _.i18n('admin.apiBlock.status', null, 'Status') )) == null ? '' : __t) +
'</th>\n        <th class="num">' +
((__t = ( _.i18n('admin.apiBlock.hits', null, 'Blocked calls') )) == null ? '' : __t) +
'</th>\n        <th>' +
((__t = ( _.i18n('admin.apiBlock.lastHit', null, 'Last') )) == null ? '' : __t) +
'</th>\n        <th>' +
((__t = ( _.i18n('admin.apiBlock.expires', null, 'Expires') )) == null ? '' : __t) +
'</th>\n        <th>' +
((__t = ( _.i18n('admin.apiBlock.created', null, 'Created') )) == null ? '' : __t) +
'</th>\n        <th></th>\n      </tr>\n    </thead>\n    <tbody>\n    ';
 _.each(rules, function (rule) { ;
__p += '\n      <tr class="' +
__e( rule.status !== 'enforced' ? 'is-off' : '' ) +
'">\n        <td><span class="type-badge type-' +
__e( (rule.type || '').toLowerCase() ) +
'">' +
__e( rule.type ) +
'</span></td>\n        <td class="name-cell"><span class="row-title mono">' +
__e( rule.pattern ) +
'</span>';
 if (rule.note) { ;
__p += '<span class="row-sub">' +
__e( rule.note ) +
'</span>';
 } ;
__p += '</td>\n        <td><span class="status status-' +
__e( rule.status ) +
'">' +
__e( rule.statusLabel ) +
'</span></td>\n        <td class="num">' +
__e( rule.hitsLabel ) +
'</td>\n        <td>' +
__e( rule.lastHitLabel ) +
'</td>\n        <td title="' +
__e( rule.expiresTitle ) +
'">' +
__e( rule.expiresLabel ) +
'</td>\n        <td><span class="row-sub">' +
__e( rule.createdLabel );
 if (rule.createdByName) { ;
__p += ' · ' +
__e( rule.createdByName );
 } ;
__p += '</span></td>\n        <td class="actions">\n          <button type="button" class="btn btn-default btn-xs js-toggle" data-id="' +
__e( rule.id ) +
'" title="' +
__e( rule.status === 'enforced' ? _.i18n('admin.apiBlock.pause', null, 'Pause') : _.i18n('admin.apiBlock.resume', null, 'Resume') ) +
'"><i class="fa ' +
__e( rule.status === 'enforced' ? 'fa-pause' : 'fa-play' ) +
'"></i></button>\n          <button type="button" class="btn btn-default btn-xs js-delete" data-id="' +
__e( rule.id ) +
'" title="' +
__e( _.i18n('common.delete', null, 'Delete') ) +
'"><i class="fa fa-trash"></i></button>\n        </td>\n      </tr>\n    ';
 }); ;
__p += '\n    </tbody>\n  </table>\n  </div>\n  ';
 } ;
__p += '\n</section>\n\n<section class="panel">\n  <header class="panel-header">\n    <div class="tabs">\n      ';
 _.each(sourceTabs, function (t) { ;
__p += '\n        <button type="button" class="js-source-tab tab ' +
__e( sourceType === t ? 'active' : '' ) +
'" data-type="' +
__e( t ) +
'">\n          <i class="fa ' +
__e( t === 'IP' ? 'fa-map-marker' : (t === 'ORIGIN' ? 'fa-globe' : 'fa-server') ) +
'"></i>\n          ' +
((__t = ( t === 'IP' ? _.i18n('admin.apiBlock.ips', null, 'Client IPs') : (t === 'ORIGIN' ? _.i18n('admin.apiBlock.origins', null, 'Origins') : _.i18n('admin.apiBlock.hosts', null, 'Called hosts')) )) == null ? '' : __t) +
'\n        </button>\n      ';
 }); ;
__p += '\n      ';
 if (loadingSources) { ;
__p += '<i class="fa fa-spinner fa-spin"></i>';
 } ;
__p += '\n    </div>\n    <div class="source-tools">\n      <form class="js-source-search search">\n        <input type="search" class="js-search" value="' +
__e( search ) +
'" placeholder="' +
__e( _.i18n('common.search', null, 'Search') ) +
'" aria-label="Search" />\n      </form>\n      <div class="presets">\n        <button type="button" class="js-period preset-btn ' +
__e( period === '24h' ? 'active' : '' ) +
'" data-period="24h">24 h</button>\n        <button type="button" class="js-period preset-btn ' +
__e( period === '7d' ? 'active' : '' ) +
'" data-period="7d">7 ' +
((__t = ( _.i18n('admin.apiBlock.days', null, 'days') )) == null ? '' : __t) +
'</button>\n        <button type="button" class="js-period preset-btn ' +
__e( period === '30d' ? 'active' : '' ) +
'" data-period="30d">30 ' +
((__t = ( _.i18n('admin.apiBlock.days', null, 'days') )) == null ? '' : __t) +
'</button>\n      </div>\n    </div>\n  </header>\n\n  ';
 if (!sources.length) { ;
__p += '\n    <div class="empty">' +
((__t = ( loadingSources ? '' : _.i18n('admin.apiBlock.noSources', null, 'No calls recorded for this period') )) == null ? '' : __t) +
'</div>\n  ';
 } else { ;
__p += '\n  <div class="table-scroll">\n  <table class="stats-table">\n    <thead>\n      <tr>\n        <th class="rank">#</th>\n        <th>' +
((__t = ( sourceType === 'IP' ? 'IP' : (sourceType === 'ORIGIN' ? 'Origin' : 'Host') )) == null ? '' : __t) +
'</th>\n        <th class="num">' +
((__t = ( _.i18n('admin.apiStats.calls', null, 'Calls') )) == null ? '' : __t) +
'</th>\n        <th class="num">' +
((__t = ( _.i18n('admin.apiBlock.blocked', null, 'Blocked') )) == null ? '' : __t) +
'</th>\n        <th>' +
((__t = ( _.i18n('admin.apiBlock.lastSeen', null, 'Last seen') )) == null ? '' : __t) +
'</th>\n        <th></th>\n      </tr>\n    </thead>\n    <tbody>\n    ';
 _.each(sources, function (s, idx) { ;
__p += '\n      <tr class="' +
__e( s.ruleId ? 'is-blocked' : '' ) +
'">\n        <td class="rank">' +
__e( idx + 1 ) +
'</td>\n        <td class="name-cell"><span class="row-title mono">' +
__e( s.value ) +
'</span></td>\n        <td class="num"><strong>' +
__e( s.callsLabel ) +
'</strong></td>\n        <td class="num">' +
__e( s.blockedLabel ) +
'</td>\n        <td>' +
__e( s.lastSeenLabel ) +
'</td>\n        <td class="actions">\n          ';
 if (s.ruleId) { ;
__p += '\n            <span class="status status-enforced" title="' +
__e( s.ruleLabel ) +
'"><i class="fa fa-ban"></i> ' +
__e( s.ruleLabel ) +
'</span>\n          ';
 } else if (s.blockable) { ;
__p += '\n            <button type="button" class="btn btn-default btn-xs js-block-source" data-index="' +
__e( idx ) +
'"><i class="fa fa-ban"></i> ' +
((__t = ( _.i18n('admin.apiBlock.block', null, 'Block') )) == null ? '' : __t) +
'</button>\n          ';
 } ;
__p += '\n        </td>\n      </tr>\n    ';
 }); ;
__p += '\n    </tbody>\n  </table>\n  </div>\n  ';
 } ;
__p += '\n</section>\n';

}
return __p
};});

